import axios, { AxiosRequestConfig } from 'axios';

// Get API URL from environment variable with fallback
const API_URL = import.meta.env.VITE_APP_API_URL || 'http://localhost:8000';

// Ensure URL ends with /
const baseURL = API_URL.endsWith('/') ? API_URL : `${API_URL}/`;

const axiosServices = axios.create({
  baseURL,
  timeout: 30000, // 30 second timeout
  headers: {
    'Content-Type': 'application/json'
  }
});

// ==============================|| AXIOS - FOR DJANGO SERVICES ||============================== //

axiosServices.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem('serviceToken');
    if (accessToken) {
      config.headers['Authorization'] = `Token ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized
    if (error.response?.status === 401 && !window.location.href.includes('/login')) {
      // Clear token and redirect to login
      localStorage.removeItem('serviceToken');
      window.location.pathname = '/login';
    }

    // Handle network errors
    if (!error.response) {
      console.error('Network error:', error.message);
      return Promise.reject({
        message: 'Network error. Please check your connection and try again.'
      });
    }

    // Return error response data or generic message
    return Promise.reject((error.response && error.response.data) || 'API Error');
  }
);

export default axiosServices;

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosServices.get(url, { ...config });
  return res.data;
};

export const fetcherPost = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosServices.post(url, { ...config });
  return res.data;
};
